import { Box, styled } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useHead } from '../../application/context/head';

export const Wrapper = styled(Box)({
  position: 'relative',
  maxWidth: '100%',
  margin: '0 auto',
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
});

interface Props {
  meta?: string;
  children?: React.ReactNode;
}

const PageContainer = ({ meta = '', children }: Props) => {
  const { t } = useTranslation();
  const { setHelmetTitle } = useHead();

  useEffect(() => {
    setHelmetTitle(t(meta || ''));
  }, [meta, setHelmetTitle, t]);

  return <Wrapper>{children}</Wrapper>;
};

export default PageContainer;
